module.exports = __webpack_public_path__ + "static/img/huajuan.74fa95b7.png";